/* Dropdayz — de laatste twee stukjes oude thema-JS, jQuery-vrij.

   Stonden allebei inline in layout/theme.liquid en draaiden op jQuery:
   1. de sticky header (voegt .sticky toe aan .header-sticky bij scrollen);
   2. de slick-slider op .feature-collection-slider.

   Nummer 2 is helemaal verdwenen: op de zes belangrijkste pagina's staat
   geen enkele .feature-collection-slider meer (gecontroleerd 14 aug 2026),
   dus slick-carousel initialiseerde nergens iets. Die bibliotheek is samen
   met haar stylesheet uit de <head> gehaald.

   Nummer 1 doet nog wel werk — .header-sticky staat op elke pagina — en is
   hier in gewoon JavaScript herschreven, zodat hij niet langer hoeft te
   wachten tot jQuery geladen is. De scrollafhandeling loopt via
   requestAnimationFrame met een passieve listener; de oude versie riep bij
   elke scroll-tick rechtstreeks jQuery aan, wat op mobiel merkbaar
   schokkerig scrollt.

   Zelfde drempel als voorheen: 10 pixels. */
(function () {
  'use strict';
  var kop = document.querySelector('.header-sticky');
  if (!kop) { return; }

  var bezig = false;
  function meten() {
    bezig = false;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    kop.classList.toggle('sticky', y > 10);
  }
  window.addEventListener('scroll', function () {
    if (bezig) { return; }
    bezig = true;
    window.requestAnimationFrame(meten);
  }, { passive: true });

  meten();
})();
